import $ from 'jquery';
import _ from 'underscore';
import Util from 'root/module/util';
import View from 'view/base';
import Cache from 'root/cache';
import Model_Feedback from 'model/feedback';
import Modals from 'root/modals';

export default View.extend({
    merged_feedbacks: [],

    events: {
        'click .merged-feedback-item': 'onOpenMergedFeedback',
    },

    dom_handlers: {
        onOpenMergedFeedback: function(e) {
            var merged_feedback_id = $(e.currentTarget).data('id');

            Modals.openFeedbackSidebar(merged_feedback_id);
        },
    },

    initialize: function(options) {
        this.listenTo(this.model, 'change:merged_feedback_ids',    this.updateMergedFeedbacks);
    },

    updateMergedFeedbacks: function() {
        if (this.model.isPrimaryFeedback()) {
            var merged_feedback_ids = this.model.getMergedFeedbackIds();

            Cache.app.request({
                action: 'feedback/getAttributes',
                data: {
                    ids: merged_feedback_ids,
                },
                success: (response) => {
                    this.merged_feedbacks = response.map((item) => new Model_Feedback(item));

                    this.renderMergedFeedbacks();
                }
            });
        } else {
            this.merged_feedbacks = [];

            this.renderMergedFeedbacks();
        }
    },

    renderMergedFeedbacks: function() {
        var merged_feedback_count = this.merged_feedbacks.length;

        var feedbacks = '';

        this.merged_feedbacks.forEach((model) => {
            var subject = model.getSubject();

            feedbacks +=
            '<div class="merged-feedback-item" data-id="' + model.id + '">' +
                '<span>' + Util.htmlEntities(subject) + '</span>' +
                '<div class="text-info margin-top-4">' +
                    '<span class="badge-id">' + model.id +'</span>' + ' <b>&bull;</b> ' + Util.moment(model.get('time')) +
                '</div>' +
            '</div>';
        });

        if (merged_feedback_count) {
            this.$el.find('.item-count').html(merged_feedback_count);
        } else {
            this.$el.find('.item-count').remove();
        }

        if (feedbacks) {
            this.$el.find('.item-content').html(feedbacks);
        } else {
            this.$el.find('.item-content').html('No merged feedeback.').addClass('empty');
        }
    },

    render: function() {
        var content =
        '<div class="item-header item-header-collapsible">' +
            '<span>Merged Feedback</span>' +
            '<span class="item-count badge-secondary-invert badge-round badge-fluid"></span>' +
        '</div>' +
        '<div class="item-content box-neutral-light"></div>';

        this.$el.html(content);

        this.updateMergedFeedbacks();

        return this;
    }
});